import React, { useState, useEffect } from 'react';
import './WhatWeDo.css';
import pic_1 from './pics/pic_1.png';
import pic_2 from './pics/pic_2.png';
import pic_3 from './pics/pic_3.png';
import pic_4 from './pics/pic_4.png';

const WhatWeDo = () => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const smallImages = [
        pic_4,
        pic_1,
        pic_2,
        pic_3
    ];
    useEffect(() => {
        const timer = setInterval(() => {
          setSelectedImageIndex((prevIndex) => (prevIndex + 1) % 4);
        }, 3000); 
    
        return () => clearInterval(timer);
      }, []);

    
    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
    };

    const renderSmallImages = smallImages.map((imageURL, index) => (
        <div
            className = {selectedImageIndex === index ? 'selected-image-container' : 'small-image'}
            key = {index}>
            <img
                src = {imageURL}
                alt = {index}
                onClick = {() => handleImageClick(index)}/>
        </div>
    ));

    const renderEnlargedImage = () => (
        <img src={smallImages[selectedImageIndex]} alt='enlargedImage'/>
    )

    return (
        <div>
            <div className='wwd-title'>
                <h1 className = "about_us_wwa_title">What We Do</h1>
                <hr/>
                <p>We host regular events and meetings, as well as online seminar and coaching sessions, inviting well-respected
                    <br/> leaders to share their leadership stories and insights on a variety of interesting topics.</p>
            </div>
            <div className='enlarged-image'>
                {renderEnlargedImage()}
            </div>
            <div className='small-image-gallary'>
                {renderSmallImages}
            </div>
        </div>
    )
}

export default WhatWeDo;